// @owners { team: patient-health }
import { Button } from '@alto/design-system';
import React from 'react';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { isPickup } from '~shared/helpers/order';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { type ShipmentMethod, type ShipmentStatus } from '~shared/types';
import { ContactUs } from '../../../alto-assistant';

type EditButtonProps = {
  readonly handleEditShipment: () => void;
  readonly method?: ShipmentMethod;
  readonly shipmentID?: number;
  readonly shipmentIsEditable?: boolean;
  readonly status?: ShipmentStatus;
};

export const EditButton = ({ handleEditShipment, method, shipmentID, shipmentIsEditable, status }: EditButtonProps) => {
  const { trackEvent } = useAnalytics();
  const pickup = method !== undefined ? isPickup(method) : undefined;

  if (status === 'delivered') {
    return null;
  }
  const onPress = () => {
    handleEditShipment();
    trackEvent({ event: EVENTS.DELIVERY_DETAILS_EDIT_BUTTON_CLICKED, additionalFields: { shipmentId: shipmentID } });
  };

  if (pickup || !shipmentIsEditable) {
    return (
      <ContactUs
        type="button"
        method="message"
        origin={CONTACT_US_ORIGIN.DeliveryDetailsPickup}
        customLabel="Contact Alto to edit"
        buttonType="secondary"
        buttonWidth="inline"
        small
      />
    );
  }

  return (
    <Button
      accessibilityLabel="Edit Delivery Details Button"
      onPress={onPress}
      small
      testID="edit-delivery-button"
      type="secondary"
      width="inline"
    >
      Edit
    </Button>
  );
};
